module.exports = __webpack_public_path__ + "static/media/No_Viewed_Projects.ef5a92f0.svg";